import { useEffect } from 'react'

import create from 'zustand'

type CryptographyVersion = 'v1' | 'v2'

interface CryptographyVersionStore {
  version: CryptographyVersion
  setVersion: (version: CryptographyVersion) => void
}

const useCryptographyVersionStore = create<CryptographyVersionStore>(set => ({
  version: 'v2',
  setVersion: version => set({ version }),
}))

const getApiUrl = () => {
  const isDevEnvironment =
    process.env.NODE_ENV === 'development' ||
    process.env.NX_ENV === 'development'

  return isDevEnvironment
    ? `${process.env.NX_DEV_PROXY_API_HOST}/ft/values`
    : `${process.env.NX_PROXY_API_HOST}/ft/values`
}

export const useVersionOf = () => {
  const { version, setVersion } = useCryptographyVersionStore()

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await fetch(getApiUrl())
        const data = await response.json()

        if (data.cryptographyVersion) {
          setVersion(data.cryptographyVersion as CryptographyVersion)
        }
      } catch (error) {
        console.error('Failed to fetch cryptography version:', error)
        // Keep v2 as default in case of error
      }
    }

    fetchVersion()
  }, [setVersion])

  return {
    cryptography_version: version,
  }
}
